// components/social/SocialShareButton.jsx
//
// On a Custom profile card (Super): one click posts photo + description to the platform used last;
// the small arrow opens the share sheet (other platform, edit the text, manage accounts).
import React, { useState } from 'react';
import { FaShareAlt, FaCaretDown } from 'react-icons/fa';
import { useSocial } from './SocialProvider';
import ShareSheet from './ShareSheet';
import { platformMeta } from '../../services/socialService';

export default function SocialShareButton({ profile, variant = 'icon' }) {
  const social = useSocial();
  const [sheet, setSheet] = useState(false);
  const [sending, setSending] = useState(false);
  if (!social?.enabled || !profile) return null;
  const meta = platformMeta(social.lastPlatform);
  const busy = sending || social.busyProfiles.has(profile.id);
  const shared = Array.isArray(profile.socialShares) ? profile.socialShares : [];
  const sharedHere = shared.some((s) => s.platform === social.lastPlatform);
  const connected = social.accounts[social.lastPlatform]?.connected;
  const title = busy ? `Posting to ${meta?.label}…`
    : `${connected ? 'Share' : 'Connect & share'} to ${meta?.label}${sharedHere ? ' (already shared there)' : ''}`;

  const oneClick = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setSending(true);
    try { await social.share(profile); } finally { setTimeout(() => setSending(false), 1500); }
  };

  return (
    <>
      {variant === 'icon' ? (
        <span className="social-share-split" onClick={(e) => e.stopPropagation()}>
          <button type="button" className={`action-btn${shared.length ? ' action-btn--active' : ''}`} title={title} disabled={busy}
            onClick={oneClick} style={{ fontSize: '14px' }}>
            {busy ? <span className="social-spinner social-spinner--sm" /> : <FaShareAlt />}
          </button>
          <button type="button" className="action-btn social-share-more" title="Share options" onClick={(e) => { e.stopPropagation(); setSheet(true); }}>
            <FaCaretDown />
          </button>
        </span>
      ) : (
        <span className="social-share-split social-share-split--wide" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="social-btn social-btn--primary" disabled={busy} onClick={oneClick}>
            <FaShareAlt /> {busy ? 'Posting…' : `Share to ${meta?.label}`}
          </button>
          <button type="button" className="social-btn" onClick={() => setSheet(true)} title="Share options"><FaCaretDown /></button>
        </span>
      )}
      {sheet && <ShareSheet profile={profile} onClose={() => setSheet(false)} />}
    </>
  );
}
